import React from 'react';

import { Model } from '../../../../../../viewer/elements/model';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { Asset } from '../../components/asset-blocks/asset';
import { ModelBody } from './model-body';
import { ModelHeader } from './model-header';

type Props = {
  asset: Model;
};

const ModelAsset = (props: Props) => {
  const [_, refresh] = useNonce();

  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  return (
    <>
      <Asset asset={props.asset}>
        {{
          header: <ModelHeader asset={props.asset} />,
          content: <ModelBody asset={props.asset} />,
        }}
      </Asset>
    </>
  );
};

export { ModelAsset, Props as ModelAssetProps };
